/* eslint-disable react/prop-types */
import React from "react";
import { Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import numberFormat from "../common/number-format";
import "./ProjectStageAnalysisTable.css";

export const ProjectStageAnalysisTable = ({
  stageList = [],
  activeProjectTab,
  setActiveProjectTab,
  projectList = [],
  hoveredIndex,
  setHoveredIndex,
  projectPerPage,
  setProjectPerPage,
  pageProjectCount,
  handlePageProjectClick,
}) => {
  return (
    <div className="bg-white rounded-4 p-3 mt-4">
      <div className="vendors-tabs-wrapper">
        <div className="vendor-tabs d-flex gap-2">
          {stageList.map((stage) => (
            <button
              key={stage.value}
              className={`vendors-tab ${
                activeProjectTab === stage.value ? "active" : ""
              }`}
              onClick={() => setActiveProjectTab(stage.value)}
            >
              <span className="fs-13 fw-600 mb-2">{stage.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div>
        <div style={{ overflowX: "auto" }}>
          <div
            className="head3"
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "center",
              height: "40px",
              padding: "0 16px",
              backgroundColor: "#F2F2F2",
            }}
          >
            <p className="fs-13 fw-700 textcolor mt-3" style={{ flex: 1 }}>
              Project code
            </p>
            <p className="fs-13 fw-700 textcolor mt-3" style={{ flex: 1 }}>
              Project Name
            </p>
            <p className="fs-13 fw-700 textcolor mt-3" style={{ flex: 1 }}>
              Start Date
            </p>
            <p className="fs-13 fw-700 textcolor mt-3" style={{ flex: 1 }}>
              End Date
            </p>
            <p className="fs-13 fw-700 textcolor mt-3" style={{ flex: 1 }}>
              Total Cost
            </p>
            <p className="fs-13 fw-700 textcolor mt-3" style={{ flex: 1 }}>
              Transaction Value
            </p>
            <p className="fs-13 fw-700 textcolor mt-3" style={{ flex: 1 }}>
              Claim Amount
            </p>
            <p className="fs-13 fw-700 textcolor mt-3" style={{ flex: 1 }}>
              Work done (%)
            </p>
          </div>

          {Array.isArray(projectList) && projectList.length > 0 ? (
            projectList.map((item, index) => (
              <div
                key={item.project_id || item.code || item.name}
                className="head3"
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "40px",
                  padding: "0 16px",
                  backgroundColor:
                    hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                  borderBottom: "1px solid #D4DDE7",
                  cursor: "pointer",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <p
                  className="fs-13 fw-500 textcolor mt-3"
                  style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                  title={item.code}
                >
                  {item.code ?? "---"}
                </p>
                <p className="fs-13 fw-500 textcolor mt-3" style={{ flex: 1 }}>
                  {item.name ?? "-"}
                </p>
                <p className="fs-13 fw-500 textcolor mt-3" style={{ flex: 1 }}>
                  {item.start_date ?? "-"}
                </p>
                <p className="fs-13 fw-500 textcolor mt-3" style={{ flex: 1 }}>
                  {item.end_date ?? "-"}
                </p>
                <p className="fs-13 fw-500 textcolor mt-3" style={{ flex: 1 }}>
                  ₹ {numberFormat(item.contract_value)}
                </p>
                <p className="fs-13 fw-500 textcolor mt-3" style={{ flex: 1 }}>
                  ₹ {numberFormat(item.transaction_value)}
                </p>
                <p className="fs-13 fw-500 textcolor mt-3" style={{ flex: 1 }}>
                  ₹ {numberFormat(item.claim_amount)}
                </p>
                <p className="fs-13 fw-500 textcolor mt-3" style={{ flex: 1 }}>
                  {item.completion_percent ?? 0}%
                </p>
              </div>
            ))
          ) : (
            <div className="d-flex align-items-center justify-content-center textGrey fs-14 fw-500" style={{ height: "100px" }}>
              No records found.
            </div>
          )}
        </div>
      </div>
      <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
        <Dropdown>
          <span className="fs-13 fw-500 textcolor">
            Records per page: &nbsp;
          </span>
          <Dropdown.Toggle
            id="dropdown-basic"
            className="bg-transparent fs-13 fw-500 textcolor border-0 custom-dropdown-toggle p-0"
          >
            <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
              {projectPerPage} <DownArrowIc />
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="my-2"
            style={{ minWidth: "unset", width: "30%" }}
          >
            {[5, 10, 25, 50, 75, 100].map((size) => (
              <Dropdown.Item
                key={size}
                onClick={() => {
                  setProjectPerPage(size);
                }}
                active={projectPerPage === size}
                className="text-center fs-13 fw-500 textcolor"
              >
                {size}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
        <div className="d-flex align-items-center gap-2">
          <ReactPaginate
            previousLabel={
              <div
                className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                style={{
                  width: "22px",
                  height: "22px",
                }}
              >
                <LarIc />
              </div>
            }
            nextLabel={
              <div
                className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                style={{
                  width: "22px",
                  height: "22px",
                }}
              >
                <RarIc />
              </div>
            }
            breakLabel={"..."}
            pageCount={pageProjectCount + 1}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageProjectClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        </div>
      </div>
    </div>
  );
};
